import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Automate Workflows & Improve{" "}
              <span>Accuracy with Custom NLP Solutions</span>
            </h2>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Consult NLP Solutions
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Deep Learning Algorithms</h4>
                  <p>
                    Implement sophisticated deep learning models for accurate
                    and high-performance NLP tasks.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Contextual Semantic Search</h4>
                  <p>
                    Enhance search accuracy by understanding the contextual
                    meaning behind queries and documents.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Advanced Speech Recognition</h4>
                  <p>
                    Convert spoken language into text using high-precision
                    speech recognition technologies.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Intelligent Information Extraction</h4>
                  <p>
                    Extract structured information from unstructured data
                    sources to streamline data processing and analysis.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Accurate Machine Translation</h4>
                  <p>
                    Deliver high-quality translations across multiple languages
                    with the correct meaning and context of the original text.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Spam Control & Filtering</h4>
                  <p>
                    Employ sophisticated algorithms to detect and filter spam,
                    ensuring clean and relevant communications.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Sentiment Analysis</h4>
                  <p>
                    Analyze text to detect emotions and sentiments to extract
                    valuable insights into customer feedback and market trends.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Efficient Summarization</h4>
                  <p>
                    Automatically generate concise summaries of large texts for
                    quick comprehension and decision-making.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Automated Query Handling</h4>
                  <p>
                    Develop systems to understand and respond to user queries
                    accurately for better customer interaction.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Dynamic Text Generation</h4>
                  <p>
                    Create contextually relevant and coherent text automatically
                    to accelerate content creation and automation.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Named Entity Recognition</h4>
                  <p>
                    Identify and classify key information entities in text,
                    aiding in better data organization and retrieval.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Language Modeling & Understanding</h4>
                  <p>
                    Employ advanced language models to comprehend and generate
                    human-like text, improving interaction quality.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
